import React from "react";
import './certifications.css'
import Slider from "react-slick";
import html from '../../images/certifications/html-desde-0.jpg'
import htmlForm from '../../images/certifications/html-formularios.jpg'
import htmlMeta from '../../images/certifications/html-metaetiquetas.jpg'
import css1 from '../../images/certifications/css-primeros-pasos.jpg'
import javaScript1 from '../../images/certifications/javascript-introduccion.jpg'
import javaScript2 from '../../images/certifications/javascript-arreglos.jpg'
import javaScript3 from '../../images/certifications/javascript-flujo-de-programa.jpg'
import javaScript4 from '../../images/certifications/javascript-crear-sitios-interactivos.jpg'
import react1 from '../../images/certifications/react-primeros pasos.jpg'
import react2 from '../../images/certifications/react-componentes.jpg'
import react3 from '../../images/certifications/react-hooks-populares.jpg'
import git from '../../images/certifications/git-introduccion.jpg'
import sql from '../../images/certifications/sql-MySQL-Introduccion.jpg'
import sql2 from '../../images/certifications/sql-Lenguaje-definicion-de-datos.jpg'
import sql3 from '../../images/certifications/sql-Insersion-de-datos.jpg'
import sql4 from '../../images/certifications/sql-Consultas-bases-de-datos.jpg'
import sql5 from '../../images/certifications/sql-Actualizar-eliminar-datos.jpg'
import seo from '../../images/certifications/seo.jpg'
import seo2 from '../../images/certifications/SEO_ Posicionamiento_orgánico_de_tu_negocio.jpg'
import seo3 from '../../images/certifications/SEO_impacto_a_tu_estrategia_de_Content_Marketing.jpg'
import react4 from '../../images/certifications/react-hooks-secundarios-y-personalizados-en react.jpg'
import react5 from '../../images/certifications/react-Crea_aplicaciones_single_page_React_Router.jpg'
import jira from '../../images/certifications/jira_gestiona_proyectos_tickets_eficiencia.jpg'
import Figma from '../../images/certifications/Figma_Funcionalidades_básicas.jpg'
import Figma2 from '../../images/certifications/Figma_Crea_tu_primera_landing_page .jpg'
import wordpress from '../../images/certifications/wordpress_crear_webs_automaticas_con_wordpress_y_la_inteligencia_artificial.jpg'
import trello from '../../images/certifications/Trello_trucos_para_gestionar_tu_trabajo.jpg'



function SampleRightArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
        className={`custom-arrow right-arrow ${className}`}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

function SampleLeftArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`custom-arrow left-arrow ${className}`}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

const settings = {
  dots: true,
  infinite: true,
  className: "center",
  pauseOnHover: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: false,
  lazyLoad: true,
  nextArrow: <SampleRightArrow />,
  prevArrow: <SampleLeftArrow />,
  responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
  ]
};


const Certifications =()=> {
    const certifications = [
      {name: "Html desde 0", descripcion: "Certificación HTML de Ubits", image: html,},
      {name: "Hmtl Formularios", descripcion: "Certificación formularios HTML de Ubits", image: htmlForm,},
      {name: "Hmtl Meta Etiquetas", descripcion: "Certificación Meta etiquetas HTML de Ubits", image: htmlMeta,},
      {name: "CSS", descripcion: "Certificación CSS de Ubits", image: css1,},
      {name: "JavasScript", descripcion: "Certificación JavaScript de Ubits", image: javaScript1,},
      {name: "JavaScript Arrays", descripcion: "Certificación JavaScript de Ubits", image: javaScript2,},
      {name: "JavaScript Flujo de Programas", descripcion: "Certificación JavaScript de Ubits", image: javaScript3,},
      {name: "JavaScript Crear sitios web Interactivos", descripcion: "Certificación JavaScript de Ubits", image: javaScript4,},
      {name: "React", descripcion: "Certificación React.js de Ubits", image: react1,},
      {name: "React Componentes", descripcion: "Certificación React.js de Ubits", image: react2,},
      {name: "React y los Hooks más populares", descripcion: "Certificación React.js de Ubits", image: react3,},
      {name: "React hooks secundarios y personalizados", descripcion: "Certificación React de Ubits", image: react4,},
      {name: "React crea aplicaciones single page React Router", descripcion: "Certificación React de Ubits", image: react5,},
      {name: "Git", descripcion: "Certificación Git de Ubits", image: git,},
      {name: "My SQL", descripcion: "Certificación MySQL de Ubits", image: sql,},
      {name: "SQL Lenguaje y definición de datos", descripcion: "Certificación SQL de Ubits", image: sql2,},
      {name: "SQL Insersion de datos", descripcion: "Certificación SQL de Ubits", image: sql3,},
      {name: "SQL Consultas a bases de datos", descripcion: "Certificación SQL de Ubits", image: sql4,},
      {name: "SQL Eliminar y Actualizar datos", descripcion: "Certificación SQL de Ubits", image: sql5,},
      {name: "SEO Marketing en buscadores", descripcion: "Certificación SEO de Ubits", image: seo,},
      {name: "SEO Posicionamiento orgánico", descripcion: "Certificación SEO de Ubits", image: seo2,},
      {name: "SEO impacto en estrategia de Content Marketing", descripcion: "Certificación SEO de Ubits", image: seo3,},
      {name: "JIRA Marketing en buscadores", descripcion: "Certificación JIRA de Ubits", image: jira,},
      {name: "Trello Marketing en buscadores", descripcion: "Certificación Trello de Ubits", image: trello,},
      {name: "Wordpress Marketing en buscadores", descripcion: "Certificación Wordpress de Ubits", image: wordpress,},
      {name: "Figma Funcionalidades básicas", descripcion: "Certificación Figma de Ubits", image: Figma,},
      {name: "Figma Crea tu primera landing page", descripcion: "Certificación Figma de Ubits", image: Figma2,},
    ];

    return (
        <div className="certifications">
            <h2>Certificaciones</h2>
            <p><strong>{certifications.length}</strong> certificaciones</p>
            <div className="certifications-container slider-container">
              <Slider {...settings}>
                {certifications.map((certifications, index)=> {
                    return (
                      <div key={index} className="certifications-card">
                        
                        <img className="img-certifications" src={certifications.image} alt={certifications.name}/>

                        <div className="certifications-hover">
                          <h3>{certifications.name}</h3>
                          <p>{certifications.descripcion}</p>
                          <a href={certifications.image} target="_blank" rel="noopener noreferrer">Ver certificación</a>
                        </div>
                      </div>
                    )
                })}
              </Slider>
                
            </div>
        </div>
    )
}

export default Certifications;